
<div class="so-overview-container">
  <div class="">
    <form v-on:submit.prevent="submitSearch">
      <div class="d-flex justify-content-start">
        <div>
          <div class="label">Date</div>
          <board-item-date-picker v-model="searchDateRange" :customClass="'boardOverview'" :columns="2" :is-range="true" :mode="'date'" />
        </div>

        <div class="search-items ml-2">
          <div class="input-group">
            <input v-debounce="submitSearch" type="text" class="form-control input-sm" placeholder="Search..." v-model="search" />
            <div class="input-group-append" @click="submitSearch">
              <i class="fa fa-search input-group-text"></i>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <table class="os-table table table-striped table-hover mt-3" v-if="items && items.length">
    <thead>
      <tr>
        <th scope="col">Name</th>
        <th scope="col">Type</th>
        <th scope="col">Created Date</th>
        <th scope="col">Archived Date</th>

        <th scope="col">Planned</th>
        <th scope="col">In Progress</th>
        <th scope="col">Done</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="so in items" :key="so.id" @click="navigateToOccurrence(so)">
        <th class="os-table-name" scope="col">{{ so.name }}</th>
        <td class="os-table-type" scope="col">{{ so.type }}</td>
        <td class="os-table-date" scope="col">
          <i class="far fa-clock"></i>
          {{ so.createdDate | formatDate }}
        </td>
        <td class="os-table-date" scope="col">
          <i class="far fa-clock"></i>
          {{ so.archivedDate | formatDate }}
        </td>
        <td class="os-table-status" scope="col">
          <div>
            <div style="width: 25px">
              {{ getItemsCount(so.boardItemsSummary, itemsStatus.Planned).count }}
            </div>
            <div class="ml-2 badge badge-pill badge-primary sh-prop-s">
              {{ getItemsCount(so.boardItemsSummary, itemsStatus.Planned).status }}
            </div>
          </div>
        </td>
        <td class="os-table-status" scope="col">
          <div>
            <div style="width: 25px">
              {{ getItemsCount(so.boardItemsSummary, itemsStatus.InProgress).count }}
            </div>
            <div class="ml-2 badge badge-pill badge-warning sh-prop-s">
              {{ getItemsCount(so.boardItemsSummary, itemsStatus.InProgress).status }}
            </div>
          </div>
        </td>
        <td class="os-table-status" scope="col">
          <div>
            <div style="width: 25px">
              {{ getItemsCount(so.boardItemsSummary, itemsStatus.Done).count }}
            </div>
            <div class="ml-2 badge badge-pill badge-success sh-prop-s">
              {{ getItemsCount(so.boardItemsSummary, itemsStatus.Done).status }}
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div v-if="!items || !items.length">
    <hr />

    <div class="label justify-content-center d-flex">No Special Occurrences found</div>
  </div>

  <div v-if="loading" class="d-flex align-items-center justify-content-center p-5">
    <loading-spinner></loading-spinner>
  </div>

  <router-view></router-view>
</div>
